import { render, staticRenderFns } from "./ImageZoomComponent.vue?vue&type=template&id=25e40dfe&scoped=true&"
import script from "./ImageZoomComponent.vue?vue&type=script&lang=ts&"
export * from "./ImageZoomComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ImageZoomComponent.vue?vue&type=style&index=0&id=25e40dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e40dfe",
  null
  
)

export default component.exports